import React, { useState } from "react";

const STEPS = {
  1: "GET_BOX",
  2: "COLLECT",
  3: "CLAIM",
};

const StepText = (props) => {
  return (
    <>
      <div className="mechanics__tabs-title">{props.title}</div>
      <div className="mechanics__tabs-text">{props.text}</div>
    </>
  );
};

const StepContent = () => {
  return (
    <>
      <li className="mechanics__item">
        <span />
      </li>
      <li className="mechanics__item">
        <span />
      </li>
      <li className="mechanics__item">
        <span />
      </li>
    </>
  );
};

const GameMechanics = (props) => {
  const [currentStep, setCurrentStep] = useState(STEPS[1]);

  return (
    <div className="mechanics__wrapper">
      <div className="mechanics__title-bg">
        <div className="mechanics__container">
          <div className="mechanics__title">
            <div className="mechanics__variants">
              <span title="Burger variant icon" className="variant--burger" />
              <span title="Fries variant icon" className="variant--fries" />
              <span title="Shake variant icon" className="variant--shake" />
            </div>
            Make sure to complete your <strong>Real Artist</strong> Set of the same variant to
            get a special NFT reward!
          </div>
        </div>
      </div>
      <div className="mechanics__steps">
        <div className="mechanics__container">
          <ul className="mechanics__tabs">
            {Object.keys(STEPS).map((key) => {
              return (
                <li
                  className="mechanics__trigger"
                  role="button"
                  data-current={currentStep === STEPS[key] && true}
                  alt={STEPS[key]}
                  key={key}
                  onClick={() => setCurrentStep(STEPS[key])}>
                  {key}
                </li>
              );
            })}
          </ul>
          <div className="mechanics__content" data-step={currentStep}>
            {(() => {
              switch (currentStep) {
                case STEPS[1]:
                  return (
                    <>
                      <StepText
                        title="Scan the QR on your Keep It Real Meals box"
                        text="You can choose from the three available options: The Cornell Haynes Jr. Meal, the Larissa Machado Meal, or The Chase Hudson Meal."
                      />
                      <ul className="mechanics__rewards" data-circle={false}>
                        {props.artists.map((artist, index) => {
                          return (
                            <li
                              key={index}
                              data-artist={artist.id}
                              className="mechanics__item">
                              <span>aka {artist.alias}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                case STEPS[2]:
                  return (
                    <>
                      <StepText
                        title="Collect your cards and complete a set!"
                        text="Each Artist has a set of three cards (Flippable, Signature, and Behind the Scenes). Each set has three different suits (Burger, Shake or Fries). Collect a set of three  cards from the same artist with the same suit to unlock a special reward!"
                      />
                      <ul className="mechanics__rewards" data-circle={true}>
                        <StepContent />
                      </ul>
                    </>
                  );
                case STEPS[3]:
                  return (
                    <>
                      <StepText
                        title="Receive your special NFT reward"
                        text="Once you complete a set, prepare to unlock one of the special rewards, ranging from: a cool Burger King 3D NFT of The BK Crown, The King or The Subservient Chicken; a gift card for Real Food for a year; special backstage content from a featured artist; or, if you are lucky, a real call with one of the artists."
                      />
                      <ul className="mechanics__rewards" data-circle={true}>
                        <StepContent />
                      </ul>
                    </>
                  );
              }
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameMechanics;
